const faChevronLeft = {
  prefix: 'fal',
  iconName: 'chevron-left',
  icon: [320, 512, [], 'f053', 'M20.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 256 235.3 436.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-192-192z'],
};
export default faChevronLeft;
